import { useCallback, useRef, useEffect } from "react";
import { authServer, getCookie } from "../api/axios";

export default function TokenRefresh() {
    const intervalRef = useRef();
    const getToken = useCallback(async () => {
        var currentdate = new Date();
        let rft = getCookie("rft");
        if (rft) {
            const response = await authServer
                .post(
                    process.env.REACT_APP_AUTH_TOKEN_URL,
                    {
                        client_id: `${process.env.REACT_APP_AUTH_SERVER_CLIENTID}`,
                        grant_type: "refresh_token",
                    },
                    {}
                )
                .then((r) => {})
                .catch((error) => {
                    if (error.response.status === 400) {
                        if (
                            error.response.data.error_description === "Session not active"
                        ) {
                            //User no longer Authorized or has become unauthorized since login
                            window.location.href =
                                window.location.origin + "/sessionexpired";
                        }
                    }
                });
        }
    }, []);
    useEffect(() => {
        getToken();
        const interval = setInterval(
            () => getToken(),
            process.env.REACT_APP_AUTH_TOKEN_REFRESH_INTERVAL
        );
        intervalRef.current = interval;
        return () => clearInterval(interval);
    }, [getToken]);

    return <></>;
}
